module.exports = __webpack_public_path__ + "static/media/repair-grandson2.e1057ac5.jpg";